import axios from "axios";
import env from "../variables/EndpointEnvironment";

const InvestorsBannerChildAPI = (props) => {
    return axios.get(`${env.HOST}/child-hubungan-investor?category=${props.category}`, {
        headers: {
            "Content-Language": localStorage.getItem('i18nextLng'),
        },
    });
};

export default InvestorsBannerChildAPI;